var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.7422C3.29401 15.935 2.5 14.5602 2.5 13C2.5 10.6564 4.29151 8.73129 6.57974 8.51937C7.04781 5.67213 9.52024 3.5 12.5 3.5C15.4798 3.5 17.9522 5.67213 18.4203 8.51937C20.7085 8.73129 22.5 10.6564 22.5 13C22.5 14.5602 21.706 15.935 20.5 16.7422M8.5 16.5L12.5 12.5M12.5 12.5L16.5 16.5M12.5 12.5V21.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage37);
export default __webpack_public_path__ + "static/media/Image37.ae4796fd5b44d0904e6b72900fde0339.svg";
export { ForwardRef as ReactComponent };